import { forwardRef } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  CapitalAmount,
  setBalanceDialog,
} from "../../../../app/slices/capitalAmountSlice";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CapitalAmountBalanceForm = () => {
  const _Balance = useSelector((state) => state.capitalAmount.balance);
  const _SearchBody = useSelector((state) => state.capitalAmount.searchBody);
  const loading = _Balance.loading;

  const { control, handleSubmit } = useForm({
    defaultValues: _Balance.form,
  });

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(
      CapitalAmount.transfer(
        {
          amount: Number(data.amount),
          capital_amount_id: _Balance.capital_amount_id,
          transfer_type_id: _Balance.type === "deposit" ? 1 : 2,
        },
        _SearchBody
      )
    );
  };

  const handleDialog = () => {
    dispatch(
      setBalanceDialog({
        id: null,
        type: null,
      })
    );
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <Dialog
      open={_Balance.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {_Balance.type === "deposit" ? "اضافة رصيد" : "سحب رصيد"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="amount"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="المبلغ"
                    fullWidth
                    {...field}
                    InputProps={{
                      inputComponent: NumericFormatCustom,
                      startAdornment: (
                        <InputAdornment position="start">IQD</InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CapitalAmountBalanceForm;
